import { io } from 'socket.io-client';
import { baseUrl } from './apiRoutes';
import { joinExisting } from './utils';
import localforage from 'localforage';

const socketUrl = joinExisting([baseUrl, 'socket']);

export const socket = io(
  socketUrl,
  {
    transports: ['websocket'],
    // autoConnect: false,
    auth: (cb) => {
      const creds = localStorage.getItem('credentials') ? JSON.parse(localStorage.getItem('credentials')) : null;

      if (!creds) {
        cb();
        return;
      }
      cb({
        token: creds.accessToken,
      })
    },
  },
);
